import { AUTH_AS_QUERY_PARAM } from './tab-auth-as';

/**
 * Builds an in-app URL that starts tab-scoped impersonation via `auth_as`.
 * Opening this in a new browser tab captures the override in that tab only.
 */
export function buildTabAuthAsAppUrl(userId: string, path = '/'): string {
  const params = new URLSearchParams({ [AUTH_AS_QUERY_PARAM]: userId });
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedPath}?${params.toString()}`;
}
